import React, { useEffect, useState } from 'react'
import { Create, useTranslate } from 'react-admin'
import {
  Autocomplete,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Skeleton,
  Tab,
  Tabs,
  TextField,
} from '@mui/material'
import { Add, ExpandMore, Search } from '@mui/icons-material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { ModalPassenger } from './logic/modals/ModalPassenger'
import { HotelForm } from './logic/hotel/HotelForm'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import dayjs from 'dayjs'
import { paxServices } from 'src/services/reservation/pax/pax.service'
import { CarForm } from './logic/car/CarForm'
import { AssistanceForm } from './logic/assistance/AssistanceForm'
import { TransferForm } from './logic/transfer/TransferForm'
import { HotelProduct } from './logic/hotel/HotelProduct'
import { AirForm } from './logic/air/AirForm'
import { OtherForm } from './logic/other/OtherForm'
import { productServices } from 'src/services/reservation/product/product.service'
import { CarProduct } from './logic/car/CarProduct'
import { AssistanceProduct } from './logic/assistance/AssistanceProduct'
import { TransferProduct } from './logic/transfer/TransferProduct'
import { AirProduct } from './logic/air/AirProduct'
import { OtherProduct } from './logic/other/OtherProduct'
import { TrainSegmentForm } from './logic/train/TrainSegmentForm'
import { TrainSegmentProduct } from './logic/train/TrainSegmentProduct'
import { PassengerReservation } from './logic/passenger/PassengerReservation'
import { GeneralSectionCreation } from './logic/common/GeneralSectionCreation'
import { TrainPassesForm } from './logic/train/TrainPassesForm'
import { TrainPassesProduct } from './logic/train/TrainPassesProduct'
import { useLocation } from 'react-router-dom'
import { updateLocalStorage } from 'src/helper/localStore/updateLocalStorage'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { useAppState } from 'src/components/layouts/layoutTopNav'
import { getAllChildrensId } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getAllChildrensId'
import { ReservationInfoProvider } from './context/ReservationContext'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { useForm, FormProvider } from 'react-hook-form'

const TabPanel = ({ children, value, index, ...props }) => {
  return (
    <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} {...props}>
      {value === index && <>{children}</>}
    </div>
  )
}

export const ReservationCreate = (props) => {
  const { updateCustomTitle } = useAppState()
  const translate = useTranslate()
  const location = useLocation()
  const [selectedTab, setSelectedTab] = useState(0)
  const [workUnits, setWorkUnits] = useState([])
  const [loadingWorkUnits, setLoadingWorkUnits] = useState(false)
  const [selectedWorkUnit, setSelectedWorkUnit] = useState(null)
  const [timeoutClients, setTimeoutClients] = useState()
  const [clients, setClients] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const [reservation, setReservation] = useState()
  const [loadingReservation, setLoadingReservation] = useState(false)
  const [openPassengerModal, setOpenPasaggerModal] = useState(false)
  const [passengers, setPassengers] = useState([])
  const [newPassengers, setNewPassengers] = useState([])
  const [availableProducts, setAvailableProducts] = useState([])
  const [anchorEl, setAnchorEl] = useState()
  const [productsTabs, setProductsTabs] = useState([])
  const [openProductModal, setOpenProductModal] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState()
  const [searchBy, setSearchBy] = useState(null)
  const [basesList, setBasesList] = useState([])
  const [selectedBase, setSelectedBase] = useState(null)
  const [loadingBases, setLoadingBases] = useState(false)
  const formMethods = useForm()

  useEffect(() => {
    updateCustomTitle('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (location.pathname === '/reservation/create') {
      updateLocalStorage('reservation', JSON.stringify(reservation))
    }

    return () => {
      if (location.pathname === '/reservation/create') {
        localStorage.removeItem('reservation')
      }
    }
  }, [location.pathname, reservation])

  useEffect(() => {
    if (selectedClient?.id) {
      fetchBases(selectedClient.id)
    }
  }, [selectedClient?.id])


  const onChangeSelectedWorkClient = (e) => {
    const { value } = e.target
    setSelectedWorkUnit(value)
    setSelectedClient(null)
    setClients([])
  }

  const fetchBases = async (businessUnitId) => {
    setLoadingBases(true)
    try {
      const data = await reservationServices.getAllBases(businessUnitId)
      const options = (data.options || []).map((name) => ({ name }))
      setBasesList(options)
      if (data.selected) {
        setSelectedBase({ name: data.selected })
      } else {
        setSelectedBase(null)
      }
    } catch (error) {
      setBasesList([])
      setSelectedBase(null)
    } finally {
      setLoadingBases(false)
    }
  }
  

  const getWorkUnitByid = async (id) => {
    try {
      const work_unit = await workUnitServices.getById(id)
      if (work_unit) {
        return work_unit
      }
      return null
    } catch (error) {
      console.log('getWorkUnitByid error', error)
    }
  }

  const onChangeClient = (value) => {
    clearTimeout(timeoutClients)
    if (value && selectedWorkUnit && searchBy) {
      const timeout = setTimeout(async () => {
        setLoadingClients(true)
        const work_unit = await getWorkUnitByid(selectedWorkUnit.id)
        if (!work_unit) {
          return
        }
        const workUnitIds = getAllChildrensId(work_unit)
        let params = {}
        if (isNaN(value)) {
          params[searchBy] = value
          params['work_unit_id__in'] = workUnitIds.map((id) => id).join(',')
        } else {
          params['id'] = value
          params['work_unit_id__in'] = workUnitIds.map((id) => id).join(',')
        }
        try {
          const response = await businessUnitServices.business_unit_filter(params)
          setClients(response)
        } catch (error) {
          setClients([])
        } finally {
          setLoadingClients(false)
        }
      }, 1000)
      setTimeoutClients(timeout)
    } else {
      setClients([])
    }
  }

  const onChangeSelectedClient = (client) => {
    if (!client) {
      setClients([])
    }

    setSelectedClient(client)
  }

  const createReservation = async () => {
    const data = {
      business_unit_id: selectedClient.id,
      work_unit_id: selectedWorkUnit.id,
      ...(hasPermissionFunction('reservation', 'show_base') && selectedBase?.name
        ? { base_to_billing: selectedBase.name }
        : {}),
    }

    setLoadingReservation(true)
    const createdReservation = await reservationServices.createReservationManual(data)
    const reservationAux = await reservationServices.getById(createdReservation.id)
    const baseName = reservationAux.bases_relation?.name || ''
    updateCustomTitle(createdReservation.number || '')
    setReservation({
      ...reservationAux,
      product: createdReservation.product || [],
      base_to_billing: baseName,
    })
    setLoadingReservation(false)

    const products = await productServices.getProductByWorkUnitId(selectedWorkUnit.id, true)
    setAvailableProducts(products)
  }

  const getReservation = async (reservationId) => {
    setLoadingReservation(true)
    const reservationAux = await reservationServices.getById(reservationId)
    setReservation({
      ...reservation,
      ...reservationAux,
    })

    const passengersAux = newPassengers.filter(
      (elem) => !reservationAux.passengers.find((passenger) => passenger.id === elem.id)
    )
    setPassengers([...reservationAux.passengers, ...passengersAux])
    setLoadingReservation(false)
  }

  const onSubmitPassenger = async (data) => {
    delete data.item_relation
    data.birth_date = data.birth_date ? dayjs(data.birth_date).format('DD-MM-YYYY') : null

    const pax = await paxServices.createPax(data)
    setPassengers([...passengers, pax])
    setNewPassengers([...newPassengers, pax])
    setOpenPasaggerModal(false)
    setSelectedTab(1)
  }

  const onUpdatePassenger = async (data) => {
    delete data.item_relation
    const indexPassenger = passengers.findIndex((elem) => elem.id === data.id)
    if (indexPassenger > -1) {
      const passengersAux = JSON.parse(JSON.stringify(passengers))
      passengersAux.splice(indexPassenger, 1, data)
      setPassengers(passengersAux)
    }
  }

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const onSelectProduct = (value) => {
    setAnchorEl(null)
    setSelectedProduct(value)
    setOpenProductModal(true)
  }

  const handleCloseProductModal = () => {
    setOpenProductModal(false)
    setSelectedProduct(null)
  }

  const onSubmitProduct = (product, data, isOther = false) => {
    handleCloseProductModal()
    data.item_id = data.pricing_relation?.[0]?.item_id
    let productsTabsAux = JSON.parse(JSON.stringify(productsTabs))
    const productTabIndex = productsTabsAux.findIndex((elem) => elem.product === product)
    const productTab =
      productTabIndex > -1 ? productsTabsAux[productTabIndex] : { product, products: [], isOther }
    productTab.products = [...productTab.products, data]
    if (productTabIndex > -1) {
      productsTabsAux.splice(productTabIndex, 1, productTab)
    } else {
      productsTabsAux = [...productsTabsAux, productTab]
    }

    setProductsTabs(productsTabsAux)
    setSelectedTab(productTabIndex === -1 ? productsTabsAux.length + 1 : productTabIndex + 2)
    getReservation(reservation?.id)
  }

  const getProductForm = () => {
    const detail = selectedProduct?.product_relation?.ref_table_detail
    if (detail === 'hotel_detail') {
      return (
        <HotelForm
          openModal={true}
          reservation={reservation}
          passengers={passengers}
          workUnit={selectedWorkUnit}
          product={selectedProduct}
          handleClose={handleCloseProductModal}
          onSubmit={(data) => onSubmitProduct('hotel', data)}
        />
      )
    } else if (detail === 'car_detail') {
      return (
        <CarForm
          openModal={true}
          reservation={reservation}
          passengers={passengers}
          workUnit={selectedWorkUnit}
          product={selectedProduct}
          handleClose={handleCloseProductModal}
          onSubmit={(data) => onSubmitProduct('car', data)}
        />
      )
    } else if (detail === 'assistance_detail') {
      return (
        <AssistanceForm
          openModal={true}
          reservation={reservation}
          passengers={passengers}
          workUnit={selectedWorkUnit}
          product={selectedProduct}
          handleClose={handleCloseProductModal}
          onSubmit={(data) => onSubmitProduct('assistance', data)}
        />
      )
    } else if (detail === 'transfer_detail') {
      return (
        <TransferForm
          openModal={true}
          reservation={reservation}
          passengers={passengers}
          workUnit={selectedWorkUnit}
          product={selectedProduct}
          handleClose={handleCloseProductModal}
          onSubmit={(data) => onSubmitProduct('transfer', data)}
        />
      )
    } else if (detail === 'air_detail') {
      return (
        <AirForm
          openModal={true}
          reservation={reservation}
          passengers={passengers}
          workUnit={selectedWorkUnit}
          product={selectedProduct}
          handleClose={handleCloseProductModal}
          onSubmit={(data) => onSubmitProduct('flight', data)}
        />
      )
    } else if (detail === 'train_detail_segment') {
      return (
        <TrainSegmentForm
          openModal={true}
          reservation={reservation}
          passengers={passengers || []}
          workUnit={selectedWorkUnit}
          product={selectedProduct}
          handleClose={handleCloseProductModal}
          onSubmit={(data) => onSubmitProduct('train_segment', data)}
        />
      )
    } else if (detail === 'train_detail_passes') {
      return (
        <TrainPassesForm
          openModal={true}
          reservation={reservation}
          passengers={passengers}
          workUnit={selectedWorkUnit}
          product={selectedProduct}
          handleClose={handleCloseProductModal}
          onSubmit={(data) => onSubmitProduct('train_passes', data)}
        />
      )
    } else if (detail === 'other_detail') {
      return (
        <OtherForm
          openModal={true}
          reservation={reservation}
          passengers={passengers}
          workUnit={selectedWorkUnit}
          product={selectedProduct}
          handleClose={handleCloseProductModal}
          onSubmit={(data) => onSubmitProduct(selectedProduct?.product_relation?.long_name, data, true)}
        />
      )
    }
  }

  const getProductTab = (product) => {
    if (product.product === 'hotel') {
      return <HotelProduct reservation={reservation} hotel={product.products} editMode />
    } else if (product.product === 'car') {
      return <CarProduct reservation={reservation} car={product.products} editMode />
    } else if (product.product === 'assistance') {
      return <AssistanceProduct reservation={reservation} assistance={product.products} editMode />
    } else if (product.product === 'transfer') {
      return <TransferProduct reservation={reservation} transfer={product.products} editMode />
    } else if (product.product === 'flight') {
      return <AirProduct reservation={reservation} air={product.products} editMode />
    } else if (product.product === 'train_segment') {
      return <TrainSegmentProduct reservation={reservation} train_segment={product.products} editMode />
    } else if (product.product === 'train_passes') {
      return <TrainPassesProduct reservation={reservation} train_passes={product.products} editMode />
    } else if (product.isOther) {
      return <OtherProduct reservation={reservation} otherProduct={product.products} editMode />
    }
  }

  const showKeys = (business_unit) => {
    let string = ''
    const business_name = business_unit?.fiscal_data_relation?.name || business_unit?.fiscal_data_name
    const fantasy_name = business_unit?.fantasy_name
    const long_name = business_unit?.long_name

    if (business_name) {
      string += '(RS) ' + business_name
    }
    if (fantasy_name) {
      string += (business_name ? ' - (NF) ' : '') + fantasy_name
    }
    if (long_name) {
      string += (business_name || fantasy_name ? ' - (NL) ' : '') + long_name
    }

    return string
  }

  const handleInput = (event) => {
    if (searchBy === 'id') {
      const value = event.target.value
      // sacar caracteres que no sean números
      const numericValue = value.replace(/[^0-9]/g, '')
      if (value !== numericValue) {
        event.target.value = numericValue
        event.preventDefault()
      }
    }
  }

  let searchTimeoutworkUnit
  const getWorkUnit = async (user, length = 2) => {
    clearTimeout(searchTimeoutworkUnit)

    if (
      (!user?.short_name || user.short_name.length < length) &&
      (!user?.long_name || user.long_name.length < length)
    ) {
      setWorkUnits([])
      return
    }

    searchTimeoutworkUnit = setTimeout(async () => {
      try {
        setLoadingWorkUnits(true)
        const filter = {
          short_name: user?.short_name,
        }
        if (user?.long_name) {
          filter.long_name = user?.long_name
        }
        const work_unit = await workUnitServices.getByAll(filter)
        setWorkUnits(work_unit)
      } catch (error) {
        setWorkUnits([])
      } finally {
        setLoadingWorkUnits(false)
      }
    }, 1000)
  }

  return (
    <Create {...props} actions={null} className='reservation-create'>
      <ReservationInfoProvider>
        <Tabs value={selectedTab} onChange={(e, tab) => setSelectedTab(tab)}>
          <Tab label={translate('ra.title.general')} />
          <Tab
            label={translate('ra.title.passengers')}
            disabled={passengers?.length === 0 || reservation?.items?.length === 0}
          />
          {productsTabs.map((tab, i) => (
            <Tab label={tab.isOther ? tab.product : translate(`ra.title.${tab.product}`)} key={i} />
          ))}
          <Button
            disabled={!Boolean(reservation)}
            startIcon={<Add />}
            endIcon={<ExpandMore />}
            onClick={handleOpenMenu}
          >
            {translate('ra.title.add_product')}
          </Button>
          <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleCloseMenu}>
            {availableProducts.map(
              (product, i) =>
                product.product_relation && (
                  <MenuItem key={i} onClick={() => onSelectProduct(product)}>
                    {product.product_relation.long_name}
                  </MenuItem>
                )
            )}
          </Menu>
        </Tabs>
        <Divider fullWidth />
        <TabPanel index={0} value={selectedTab} className='tab-panel'>
          {!reservation ? (
            <>
              <CardCommon title={translate('ra.title.general_information')}>
                <Grid container className='general-information'>
                  <FormProvider {...formMethods}>
                    <form onSubmit={formMethods.handleSubmit(() => {})}>
                      <EditInputsWrap
                        label={translate('ra.field.work_unit')}
                        tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
                        md={12}
                        required
                        style={{ margin: '0 0 20px 0' }}
                      >
                        <MultiAutocompleteInput
                          source={"work_unit_id"}
                          options={workUnits}
                          loading={loadingWorkUnits}
                          optionsText={['short_name', 'long_name']}
                          separator=' | '
                          optionValue='id'
                          onSearch={getWorkUnit}
                          resetOnLoad={false}
                          fields={['short_name', 'long_name']}
                          onChange={onChangeSelectedWorkClient}
                        />
                      </EditInputsWrap>
                    </form>
                  </FormProvider>
                </Grid>
              </CardCommon>

              <CardCommon title={translate('ra.title.client')} style={{ margin: '20px 0' }}>
                <Grid container>
                  {!reservation && (
                    <>
                      <EditInputsWrap md={4} label={translate('ra.field.search_by')}>
                        <Autocomplete
                          size='small'
                          options={[
                            {
                              id: 'fantasy_name__ilike',
                              name: translate('ra.field.fantasy_name'),
                            },
                            {
                              id: 'fiscal_data__name__ilike',
                              name: translate('ra.field.business_name'),
                            },
                            {
                              id: 'long_name__ilike',
                              name: translate('ra.field.long_name'),
                            },
                            {
                              id: 'id',
                              name: translate('ra.field.id'),
                            },
                          ]}
                          renderInput={(params) => <TextField {...params} label='' />}
                          getOptionLabel={(option) => option.name}
                          noOptionsText={translate('ra.validation.noOptionsText')}
                          placeholder={translate('ra.field.search_by')}
                          disabled={!Boolean(selectedWorkUnit)}
                          onChange={(e, value) => {
                            setSearchBy(value?.id)
                            setClients([])
                          }}
                        />
                      </EditInputsWrap>
                      <EditInputsWrap md={8} className='input-gray'>
                        <Autocomplete
                          size='small'
                          options={clients}
                          value={selectedClient || null}
                          getOptionLabel={(option) => showKeys(option)}
                          loading={loadingClients}
                          loadingText={translate('ra.action.loading')}
                          filterOptions={() => clients}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={translate('ra.field.search_client')}
                              onChange={(e) => onChangeClient(e.target.value)}
                              onInput={handleInput}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: <Search />,
                                endAdornment: (
                                  <>
                                    {loadingClients ? <CircularProgress color='inherit' size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          onChange={(e, value) => onChangeSelectedClient(value)}
                          noOptionsText={translate('ra.validation.noOptionsText')}
                          placeholder={translate('ra.field.search_client')}
                          disabled={!Boolean(selectedWorkUnit) || !Boolean(searchBy)}
                        />
                      </EditInputsWrap>
                    </>
                  )}

                  <EditInputsWrap label={translate('ra.field.id')} disabled>
                    <TextField size='small' fullWidth disabled value={selectedClient?.id || ''} />
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.business_type')} disabled>
                    <TextField
                      size='small'
                      fullWidth
                      disabled
                      value={selectedClient?.business_type?.long_name || ''}
                    />
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.seller')} disabled>
                    <TextField size='small' fullWidth disabled value={selectedClient?.user || ''} />
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.short_name')} disabled>
                    <TextField size='small' fullWidth disabled value={selectedClient?.short_name || ''} />
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.long_name')} disabled>
                    <TextField size='small' fullWidth disabled value={selectedClient?.long_name || ''} />
                  </EditInputsWrap>

                  <EditInputsWrap label={translate('ra.field.email')} disabled>
                    <TextField size='small' fullWidth disabled value={selectedClient?.email || ''} />
                  </EditInputsWrap>
                </Grid>
              </CardCommon>

              {hasPermissionFunction('reservation', 'show_base') && (
                <CardCommon title={translate('ra.field.base_to_billing')} style={{ margin: '20px 0' }}>
                  <Grid container>
                    <EditInputsWrap md={12} label={translate('ra.field.base_to_billing')}>
                      <Autocomplete
                        size='small'
                        options={basesList}
                        value={selectedBase || null}
                        getOptionLabel={(option) => option.name || ''}
                        loading={loadingBases}
                        loadingText={translate('ra.action.loading')}
                        noOptionsText={translate('ra.validation.noOptionsText')}
                        onChange={(e, value) => setSelectedBase(value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={translate('ra.field.base_to_billing')}
                          />
                        )}
                      />
                    </EditInputsWrap>
                  </Grid>
                </CardCommon>
              )}

              <Button
                variant='contained'
                disabled={loadingReservation || !selectedWorkUnit || !selectedClient}
                onClick={createReservation}
              >
                {translate('ra.action.save')}
              </Button>
            </>
          ) : (
            <GeneralSectionCreation reservation={reservation} />
          )}
        </TabPanel>

        <TabPanel index={1} value={selectedTab}>
          <PassengerReservation
            passengers={passengers}
            onClickButtonOpenPasaggerModal={() => setOpenPasaggerModal(true)}
            item={productsTabs.map((elem) => elem?.products || []).flat()}
            onUpdatePassenger={onUpdatePassenger}
            editMode
          />
        </TabPanel>

        {productsTabs.map((product, i) => (
          <TabPanel index={i + 2} value={selectedTab}>
            {getProductTab(product)}
          </TabPanel>
        ))}

        <ModalPassenger
          open={openPassengerModal}
          handleClose={() => setOpenPasaggerModal(false)}
          item={productsTabs.map((elem) => elem?.products || []).flat()}
          titleModal={translate('ra.title.add_passenger')}
          onSubmit={onSubmitPassenger}
        />

        {openProductModal && getProductForm()}
      </ReservationInfoProvider>
    </Create>
  )
}
